import { getItem, getSessionItem, removeSessionItem, setItem, setSessionItem } from '@/utils/storage'

/**
 * Ship customers live in the 'ship-users' database connection
 * Need to state explicitly for login and password change, because Auth0 falls back to 'test-users' as the default
 */
export const SHIP_USERS_CONNECTION = 'ship-users'

export const LAST_CUSTOMER_ID_STORAGE_KEY = 'last-customer-id'

export const setLastCustomerId = (customerId: string): void => setItem(LAST_CUSTOMER_ID_STORAGE_KEY, customerId)

export const getLastCustomerId = (): string | undefined => {
  const customerId = getItem<string>(LAST_CUSTOMER_ID_STORAGE_KEY)

  return typeof customerId === 'string' && customerId !== '' ? customerId : undefined
}

const AUTH0_LOGIN_ATTEMPT_KEY = 'auth0LoginAttempt'

// Long enough to cover an Auth0 round trip that bounces straight back, short enough that a visitor
// who simply backed out of the Auth0 page is sent there again next time
const AUTH0_LOGIN_ATTEMPT_WINDOW_MS = 30_000

export const recordAuth0LoginAttempt = (): void => setSessionItem(AUTH0_LOGIN_ATTEMPT_KEY, Date.now())

export const clearAuth0LoginAttempt = (): void => removeSessionItem(AUTH0_LOGIN_ATTEMPT_KEY)

/**
 * Loop breaker. `/login` hands visitors to Auth0, and everything that fails after the Auth0
 * callback — a rejected token, an unreachable account endpoint — bounces them back to `/login`.
 * Auth0 still holds a session at that point, so redirecting again would go round forever. A recent
 * attempt means we already tried, so `/login` should fall through to the v1 form instead.
 */
export const hasRecentAuth0LoginAttempt = (): boolean => {
  const attemptedAt = getSessionItem<number>(AUTH0_LOGIN_ATTEMPT_KEY)

  return attemptedAt !== undefined && Date.now() - attemptedAt < AUTH0_LOGIN_ATTEMPT_WINDOW_MS
}
